<div class="overlay-content">
	<div class="langs-select">
		@for (language of languages; track language) {
			<mat-option (click)="selectLanguage(language)">
			{{ language.name | translateWithKeys }}
			</mat-option>
		}
	</div>
</div>
